import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'met-totals',
  templateUrl: './totals.component.html',
  styleUrls: ['./totals.component.scss']
})
export class TotalsComponent implements OnInit {

  @Input() checkout: any;

  constructor() {

  }

  ngOnInit(): void {
  }

}
